// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__JI36q","opened":"Sidebar_opened__CEkGV"};